export default __webpack_public_path__ + "static/media/goforward.31bde090.svg";